// @ts-nocheck
import styled, { css } from 'styled-components';

export const TabStyled = styled.div<{ isSelected: boolean; theme: any }>(
  ({ isSelected, theme }) => css`
  flex: 1;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  order: -1;
  padding: 0.75rem 1.25rem 0.875rem;
  background: ${isSelected ? '#E8EDFA' : theme.white};
  border: 1px solid #8AA0CA;
  border-radius: 0.25rem;
  font-family: ${props => props.theme.fontBold};
  font-size: ${props => props.theme.fontSizeS};
  line-height: ${props => props.theme.fontSizeM};
  letter-spacing: 0;
  color: ${theme.grayUltraDark};
  cursor: pointer;

  ${
    isSelected &&
    `
    -webkit-box-shadow: 0 -0.25rem #8AA0CA inset;
    -moz-box-shadow: 0 -0.25rem #8AA0CA inset;
    box-shadow: 0 -0.25rem #8AA0CA inset;
  `
  }

  i {
    color: #8AA0CA;
  }
`
);
